import type { Mixpanel } from 'mixpanel-browser';
import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { isServiceWorkerAvailable } from '@/utils/is-service-worker-available.ts';
import { traceError } from '@/utils/trace-error.ts';
import { handleImportError } from './handle-import-error.ts';
import { initSentry } from './sentry.client.ts';

declare global {
  interface Window {
    mixpanel?: Mixpanel;
  }
}

if (__WITH_SENTRY__) {
  initSentry();
}

if (isServiceWorkerAvailable()) {
  navigator.serviceWorker
    .register('/sw.js', { scope: '/' })
    .catch((err) =>
      traceError(
        new Error('Service Worker registration failed', { cause: err }),
      ),
    );
}

handleImportError();

// uncomment if memory usage grows too large locally

// if (import.meta.env.DEV) {
//   // React 19 dev profiling emits performance.measure/mark on every render.
//   // The browser's performance buffer is unbounded, so long-running sessions
//   // with high-frequency re-renders accumulate millions of entries (multi-GB).
//   // Drop them periodically to make local memory behaviour mirror production.
//   setInterval(() => {
//     performance.clearMeasures();
//     performance.clearMarks();
//   }, 30_000);
// }

startTransition(() => {
  hydrateRoot(document, <HydratedRouter />);
});
